import React, { useState,useRef ,useEffect} from "react";
import { Button, Space, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { StarOutlined, StarFilled, StarTwoTone } from '@ant-design/icons';
import { FlagOutlined, FlagFilled, FlagTwoTone } from '@ant-design/icons';
import { EyeOutlined, EyeFilled, EyeTwoTone,MailOutlined,MobileOutlined,LinkOutlined } from '@ant-design/icons';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

import "./resumeResultsCard.scss";
import LinkJDModal from "../LinkJDModel";
import useLinkJDStore from "../../store/linkJdModal.store";
import useRDBStore from "../../store/rdb";
import ResumeViewIcon from "../../assets/resume3.png";

export default function ResumeResultsCard({
  metaData,
  pageResult,
  resume,
  applications,
  pendingRDBMetaData,
  setUserMetaData
}) {

    const navigate = useNavigate();
    const { setLinkJDModalOpen } = useLinkJDStore();
    const {rdbLinkStatusInfo,resetLinkStatusInfo,rdbLinkUserMetaData}  = useRDBStore()
    const [isFollow, setFollow] = useState(metaData.isFollow);
    const [isFavorite, setfavourite] = useState(metaData.isfavorite);
    const [isViewed, setViewed] = useState(metaData.isViewed);
    //for (let i = 0; i < localStorage.length; i++) {
    //    const key = localStorage.key(i);
    //    const value = localStorage.getItem(key);
    //    console.log(`${key}: ${value}`
    //
    //    );
    //}
  const toggleLink = () => {
       let item = { qhrid: "", ifav: isFavorite, iview:isViewed, ilink:false,ifollow :isFollow}
       var idx = checkRid()
       if (idx==-1){
          item.qhrid = resume.qhrid
          item.ilink = true
          pendingRDBMetaData.push(item) 
       }else{
          pendingRDBMetaData[idx].ilink = true
       } 
       localStorage.setItem("pendingRDBMetaData", JSON.stringify(pendingRDBMetaData));         
    };     
    useEffect(() => { 
        if(rdbLinkStatusInfo != null){
            if(rdbLinkStatusInfo.qhrid == resume.qhrid){
                toggleLink() 
                setUserMetaData([...rdbLinkUserMetaData])   
            }
            resetLinkStatusInfo()
        }
    }, [rdbLinkStatusInfo !=null]);

    const handleViewResume = () => {
      toggleView()
      navigate(`/resultsDB/${resume?.qhrid}`)
    };
    
    const handleLinkToJD = () => {
       setLinkJDModalOpen(true)
    };
    const checkRid =() =>{
       var index = -1
       pendingRDBMetaData?.map((item, idx) =>
         {
            if(item.qhrid == resume.qhrid){
                index = idx
            }
         })
        return index
    }
    const toggleFavorite = () => {
       let item = { qhrid: "", ifav: isFavorite, iview:isViewed, ilink:false,ifollow :isFollow}
       var idx = checkRid()
       if (idx==-1){
          item.qhrid = resume.qhrid
          item.ifav = !isFavorite
          pendingRDBMetaData.push(item) 
       }else{
          pendingRDBMetaData[idx].ifav = !isFavorite
       }  
       localStorage.setItem("pendingRDBMetaData", JSON.stringify(pendingRDBMetaData));            
       setfavourite(!isFavorite)
    };
    const toggleFollow = () => {
       let item = { qhrid: "", ifav: isFavorite, iview:isViewed, ilink:false,ifollow :isFollow}
       var idx = checkRid()
       if (idx==-1){
          item.qhrid = resume.qhrid
          item.ifollow = !isFollow
          pendingRDBMetaData.push(item) 
       }else{
          pendingRDBMetaData[idx].ifollow = !isFollow
       } 
       localStorage.setItem("pendingRDBMetaData", JSON.stringify(pendingRDBMetaData));                     
       setFollow(!isFollow)
    };
    const toggleView = () => {
       let item = { qhrid: "", ifav: isFavorite, iview:isViewed, ilink:false,ifollow :isFollow}
       var idx = checkRid()
       if (idx==-1){
          item.qhrid = resume.qhrid
          item.iview = true
          pendingRDBMetaData.push(item) 
       }else{
          pendingRDBMetaData[idx].iview = true
       } 
       localStorage.setItem("pendingRDBMetaData", JSON.stringify(pendingRDBMetaData));         
       setViewed(!isViewed)
    }; 

    const GetUplodedByDetails = (resumeDetail)=>{
        if(resumeDetail?.firstuploadedby.method === "By Team"){
            return {
                updatedOn: resumeDetail?.firstuploadedby.teamdetails.updatedon,
                updatedByName:resumeDetail?.firstuploadedby.teamdetails.name,
                source:resumeDetail?.firstuploadedby.teamdetails.source,
                ownership:resumeDetail?.firstuploadedby.resumeownership
            } 
        }else if(resumeDetail?.firstuploadedby.method === "By Vendor"){
            return {
                updatedOn: resumeDetail?.firstuploadedby.vendordetails.updatedon,
                updatedByName:resumeDetail?.firstuploadedby.vendordetails.name,
                source:"Vendor",
                ownership:resumeDetail?.firstuploadedby.resumeownership
            }             
        }else if(resumeDetail?.firstuploadedby.uploadedby === "Through Career Page"){
            return {
                updatedOn: resumeDetail?.firstuploadedby.portaldetails.updatedon,
                updatedByName:resumeDetail?.firstuploadedby.portaldetails.name,
                source:"Career",
                ownership:resumeDetail?.firstuploadedby.resumeownership
            } 
        }else{           
            return {
                updatedOn: resumeDetail?.firstuploadedby?.portaldetails?.updatedon,
                updatedByName:resumeDetail?.firstuploadedby?.portaldetails?.name,
                source:"Portal",
                ownership:resumeDetail?.firstuploadedby.resumeownership
            } 
       }
    }
    function GetUploadingDate(resume){
        var uDetails = GetUplodedByDetails(resume)
        return uDetails.updatedOn
    }
    return (
    <div
      className="resumeResultsCard-wrapper"
    >
      <div className="resumeResultsCard-name">
                <div className="resumeResultsCard-name-row" onClick={handleViewResume}                     
                     style={{
                        cursor: "pointer",
                     }}>
                  [ {resume?.qhrid} ] {resume?.personaldetail?.name}
                </div>
        <div className="resumeResultsCard-name-row">
          Uploading Date: {GetUploadingDate(resume)}
        </div>
      </div>
      {
        resume?.employmentdetails?.noticeperiod?.officialnp == 1024
        &&  resume?.employmentdetails?.noticeperiod?.negotiableto == 1024?
        <></>
        :<>
            <div className="resumeResultsCard-current">
              <div className="resumeResultsCard-current-row">
                <div className="resumeResultsCard-current-column">Designation</div>
                <div className="resumeResultsCard-current-column">
                  : {resume?.employmentdetails?.designation}
                </div>
                <div className="resumeResultsCard-current-column">Company</div>
                <div className="resumeResultsCard-current-column">
                  : {resume?.employmentdetails?.currentcompany}
                </div>
                <div className="resumeResultsCard-current-column">Current CTC</div>
                <div className="resumeResultsCard-current-column">
                  : {resume?.employmentdetails?.currentctc?.totalctc} LPA
                </div>
                <div className="resumeResultsCard-current-column">Notice Period</div>
                <div className="resumeResultsCard-current-column">
                  :{" "}
                  {resume?.employmentdetails?.noticeperiod?.officialnp == "1024"
                    ? "-"
                    : resume?.employmentdetails?.noticeperiod?.officialnp+"/"+resume?.employmentdetails?.noticeperiod?.negotiableto} days
                </div>
                <div className="resumeResultsCard-current-column">LWD</div>
                <div className="resumeResultsCard-current-column">
                  : {resume?.employmentdetails?.noticeperiod?.lwd} 
                </div>
                <div className="resumeResultsCard-current-column">ECTC</div>
                <div className="resumeResultsCard-current-column">
                  : TDB
                </div>                
              </div>
              <div className="resumeResultsCard-current-row">
                <div className="resumeResultsCard-current-column">
                  Current Location
                </div>
                <div className="resumeResultsCard-current-column">
                  : {resume?.employmentdetails?.currentlocation}
                </div>
                <div className="resumeResultsCard-current-column">
                  Preferred Location
                </div>
                <div className="resumeResultsCard-current-column">:</div>
                <div className="resumeResultsCard-current-column">Experience</div>
                <div className="resumeResultsCard-current-column">:</div>
                <div className="resumeResultsCard-current-column">Education</div>
                <div className="resumeResultsCard-current-column">:</div>
                <div className="resumeResultsCard-current-column">Work Mode</div>
                <div className="resumeResultsCard-current-column">:</div>
                <div className="resumeResultsCard-current-column">Skills</div>
                <div className="resumeResultsCard-current-column">: {resume?.skilltags}</div>                
              </div>
            </div>             
        </>
      }
      <div className="resumeResultsCard-othes">  
        <Tooltip placement="bottom" title= {resume?.personaldetail?.email == ""? "--": resume?.personaldetail?.email}>  
           <Space><MailOutlined /></Space>           
        </Tooltip>              
        <Tooltip placement="bottom" title= {resume?.personaldetail?.mobile == ""? "--": resume?.personaldetail?.mobile}>           
           <Space><MobileOutlined /></Space>   
        </Tooltip>        
        <Space onClick={() => handleLinkToJD()}><LinkOutlined /></Space>
        <div className="resumeResultsCard-Icons">
          <Tooltip placement="bottom" title={"Favourites"}>
            <Space onClick={toggleFavorite}>
              {isFavorite ? (
                <StarTwoTone twoToneColor="#eb2f96"  />
              ) : (
                <StarOutlined style={{marginTop: '5px'}}/>
              )}
            </Space>
          </Tooltip>
        </div>
        <div className="resumeResultsCard-Icons">
          <Tooltip placement="bottom" title={"Follow"}>
            <Space onClick={toggleFollow}>
              {isFollow ? (
                <FlagTwoTone twoToneColor="#eb2f96" />
              ) : (
                <FlagOutlined style={{marginTop: '5px'}}/>
              )}
            </Space>
          </Tooltip>
        </div>
        <div className="resumeResultsCard-Icons">
          <Tooltip placement="bottom" title={"Already Viewed"}>
            <Space>{isViewed ? <EyeOutlined /> : <></>}</Space>
          </Tooltip>
        </div>
        <LinkJDModal
          jdList={pageResult?.jdidlist}
          rID={resume?.qhrid}
          emailID={resume?.personaldetail?.email}
          mobile={resume?.personaldetail?.mobile}
        />
      </div>
    </div>
  );
}
